import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { useAuthStore } from '@/stores/authStore';

import enAuth from '../translations/en/auth.json';
import enComponents from '../translations/en/components.json';
import enHome from '../translations/en/home.json';
import enLearningCenter from '../translations/en/learningCenter.json';
import enManagementPanel from '../translations/en/managementPanel.json';
import enNotifications from '../translations/en/notifications.json';
import enProgressCenter from '../translations/en/progressCenter.json';
import enScheduling from '../translations/en/scheduling.json';
import enUtils from '../translations/en/utils.json';
import enCAAuth from '../translations/en-CA/auth.json';
import enCAComponents from '../translations/en-CA/components.json';
import enCAHome from '../translations/en-CA/home.json';
import enCALearningCenter from '../translations/en-CA/learningCenter.json';
import enCAManagementPanel from '../translations/en-CA/managementPanel.json';
import enCANotifications from '../translations/en-CA/notifications.json';
import enCAProgressCenter from '../translations/en-CA/progressCenter.json';
import enCAScheduling from '../translations/en-CA/scheduling.json';
import enCAUtils from '../translations/en-CA/utils.json';

export const i18nDefaultNS = 'utils';

export const i18nResources = {
  en: {
    auth: enAuth,
    utils: enUtils,
    home: enHome,
    components: enComponents,
    learningCenter: enLearningCenter,
    progressCenter: enProgressCenter,
    managementPanel: enManagementPanel,
    notifications: enNotifications,
    scheduling: enScheduling,
  },
  'en-CA': {
    auth: enCAAuth,
    utils: enCAUtils,
    home: enCAHome,
    components: enCAComponents,
    learningCenter: enCALearningCenter,
    progressCenter: enCAProgressCenter,
    managementPanel: enCAManagementPanel,
    notifications: enCANotifications,
    scheduling: enCAScheduling,
  },
} as const;

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).init({
  resources: i18nResources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: i18nDefaultNS,
});

useAuthStore.subscribe(() => {
  const countryCode = useAuthStore.getState().userData?.center.countryCode;
  const desired = countryCode === 'CA' ? 'en-CA' : 'en';
  if (i18n.language !== desired) {
    void i18n.changeLanguage(desired);
  }
});

export { default } from 'i18next';
